//export const backendRoot = "http://127.0.0.1:8000";

// Default stays the production backend, so deployed builds are unchanged.
// Local dev overrides it via REACT_APP_BACKEND_ROOT in the untracked .env.local.
export const backendRoot =
  process.env.REACT_APP_BACKEND_ROOT || "https://intellidrop-backend.skyovi.com";
